<template>
	<div>
		<el-drawer :visible.sync="drawer_model" :title="drawer_title" :size="drawer_size" @opened="drawer_onshow"
			@closed="drawer_onhide">
			<div class="flex" style="box-sizing: border-box;padding: 10px;flex-direction: column;width: 100%;height: 100%;position: relative;">
				<div style="height: 60%;position: relative;">
					<vxe-grid style="" ref="orderdetail" v-if="list_gridOptions" v-bind="list_gridOptions"
						@toolbar-button-click="list_toolbarButtonClickEvent"
						@header-cell-click="headerCellClick"></vxe-grid>
				</div>
				<div style="height: 40%;" id="singleChart"></div>
			</div>
		</el-drawer>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import drawerMixins from '@_system/components/base/mixins/drawer/drawer.js'
	import * as echarts from 'echarts';
	export default {
		mixins: [listMixins, drawerMixins],
		props: {
			currentrow: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				list_autorender: false,
				drawer_model: false,
				drawer_title: '',
				drawer_size: '80%',
				list_formConfig: [{
					field: 'timestamp',
					title: '日期',
					itemRender: {
						name: '$datePicker'
					}
				}],
				list_footerField: [{
					field: 'salesrevenue',
					toFixed: 2
				}, {
					field: 'payTotalByrCnt',
					toFixed: 2
				}, {
					field: 'seGuidePayByrCnt',
					toFixed: 2
				}, {
					field: 'charge',
					toFixed: 2
				}, {
					field: 'itemCost',
					toFixed: 2
				}],
				chart: null,
				sourcedata: [],
				columns: [],
				toolbarButton: []
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			drawer_init() {
				if (this.currentrow) {
					this.drawer_title = '【' + this.currentrow.code + '】' + this.currentrow.title
					this.list_init()
				}
			},
			drawer_onhide() {
				this.list_gridOptions = false
				this.chart.clear()
				this.chart = false
			},
			createChart(columns = {
				field: 'salesrevenue',
				title: '净销售额',
			}) {
				this.statisticsChart(columns)
			},
			statisticsChart(columns) {
				let data = JSON.parse(JSON.stringify(this.sourcedata))
				let dataindex = 0
				let xarr = []
				let series = []
				let seriesdata = []
				let markPointdata = []

				data = this.$Lodash.groupBy(data, 'date')
				for (let i in data) {
					let value = data[i][0][columns.field]
					xarr.push(i)
					seriesdata.push(value)
					if (data[i][0]['flowuptime']) {
						data[i][0]['flowuptime'].forEach((fitem,index)=>{
							markPointdata.push({
								coord: [dataindex, value],
								symbol: 'circle',
								symbolSize: 20,
								symbolRotate: 0,
								symbolOffset: [0, -40*(index+1)],
								value: '跟',
								content:window.systemMethods.getstaff(fitem['staffid']) + '：'+fitem['content'],
								dataindex:dataindex
							})
						})
					}
					dataindex++
				}

				series.push({
					name: columns.title,
					type: 'line',
					label: {
						show: true,
						position: 'top'
					},
					emphasis: {
						focus: 'series'
					},
					markPoint: {
						data: markPointdata
					},
					data: seriesdata
				})
				console.log(series)
				if (this.chart) {
					this.chart.clear()
				} else {
					this.chart = echarts.init(document.getElementById('singleChart'))
				}
				this.chart.setOption({
					title: {
						text: columns.title,
						textStyle: {
							fontSize: 14
						}
					},
					legend: {
						data: []
					},
					grid: {
						left: '2%',
						right: '2%',
						bottom: '2%',
						containLabel: true
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						formatter: function(params) {
							let markPointData = series[params[0]['seriesIndex']]['markPoint']['data']
							
							let exist = markPointData.filter((item)=>{
								return item.dataindex == params[0]['dataIndex']
							})
							let resData = `${xarr[params[0]['dataIndex']]}<br />${columns.title}：${params[0].data}`
							exist.forEach((item)=>{
								resData += `<br />${item.content}`
							})
							return resData
						}
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar', 'stack']
							},
							restore: {
								show: false
							},
							saveAsImage: {
								show: true
							}
						}
					},
					xAxis: {
						data: xarr
					},
					yAxis: {},
					series: series
				})


				//console.log(xarr,this.tableData)

			},
			headerCellClick(e) {
				console.log(e)
				if (e.column.field != 'date') {
					this.createChart(e.column)
				}
			},
			list_beforeCreateGrid(gridOptions) {
				// gridOptions.cellStyle = this.cellStyle
				gridOptions.id = 'singlegoodslist'
				gridOptions.columns = this.getColumns()
				// gridOptions.toolbarConfig.buttons = this.toolbarButton
				// gridOptions.proxyConfig.autoLoad = true
				gridOptions.height = '100%'
				// gridOptions.formConfig = false
				// gridOptions.scrollY = {
				// 	enabled: false
				// }
			},
			list(page, updateForm) {
				return new Promise((resolve) => {
					this.$api.BIshopgoods.get({
						...page,
						...updateForm,
						...{
							single: 1,
							code: this.currentrow ? this.currentrow.code : null,
						},
					}).then((res) => {
						res.forEach((item) => {
							item.payPct = 0
							if (item.payTotalByrCnt) {
								item.payPct = (item.payAmt / item.payTotalByrCnt).toFixed(2)
							}
							item.itemCost = item.costdetail ? item.costdetail.toFixed(2) : null
						})
						this.sourcedata = res
						this.createChart()
						resolve({
							list: res
						})
					}, () => {
						resolve()
					})
				})
			},
			getColumns() {
				let columns = [{
						field: 'payAmt',
						title: '支付金额',
						sortable: true
					},
					{

						field: 'sucRefundAmt',
						title: '成功退款金额',
						sortable: true,
					},
					{

						field: 'salesrevenue',
						title: '净销售额',
						sortable: true,
					},
					{
						field: 'newPayByrCnt',
						title: '支付新买家数',
						sortable: true
					},
					{
						field: 'payOldByrCnt',
						title: '支付老买家数',
						sortable: true
					},

					{
						field: 'payTotalByrCnt',
						title: '支付总人数',
						sortable: true
					},
					{
						field: 'payRate',
						title: '支付转化率',
						sortable: true,
						formatter: ({
							cellValue
						}) => {
							return (cellValue * 100).toFixed(2) + '%'
						}
					},
					{
						field: 'itmUv',
						title: '商品访客数',
						sortable: true
					},
					{
						field: 'seGuideUv',
						title: '搜索访客数',
						sortable: true
					},
					{
						field: 'seGuidePayByrCnt',
						title: '搜索支付买家数',
						sortable: true
					},
					{
						field: 'seGuidePayRate',
						title: '搜索支付转化率',
						sortable: true,
						formatter: ({
							cellValue
						}) => {
							return (cellValue * 100).toFixed(2) + '%'
						}
					},
					{
						field: 'uvValue',
						title: 'UV价值',
						sortable: true
					},
					{
						field: 'payPct',
						title: '客单价',
						sortable: true
					},
					{
						field: 'charge',
						title: '花费',
						sortable: true
					},
					{
						field: 'chargePercent',
						title: '花费占比',
						sortable: true,
						formatter: ({
							cellValue
						}) => {
							return cellValue + '%'
						}
					},
					{
						field: 'itemCost',
						title: '发货成本',
						slots: {
							default: ({
								row
							}) => {
								return <div> <div style ="font-weight:bolder;display:inline-block;font-size:14px" > {row.itemCost} </div></div>
							}
						}
					},
					{
						field: 'date',
						title: '日期',
						sortable: true
					},
				]
				columns.forEach((item) => {
					item.showHeaderOverflow = 'tooltip'
				})
				return columns
			},
		},
		components: {

		}
	}
</script>